import { FC, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { navigationBottomBarRoutes } from "../routes/routes/modules";

const NavigationLayout = () => {
    return <div className="w-full h-full relative">
        <div>
            <Outlet />
        </div>
        <BottomNavigationBar />
    </div>
}


const BottomNavigationBar = () => {
    const routes = navigationBottomBarRoutes;
    const [currentRoute, setCurrentRoute] = useState(routes[0]);
    const location = useLocation();
    useEffect(() => {
        const pathname = location.pathname;
        for (let route of routes) {
            if (route.path === pathname) {
                setCurrentRoute(route);
            }
        }
    }, [location.pathname]);
    return <div className="w-full p-4 py-2 border-t  fixed z-50 bottom-0 left-0 bg-white dark:bg-black border-border">
        <div className="max-w-screen-lg mx-auto ">
            <div className="w-full h-full flex">
                {
                    routes.map((route, index) => {
                        return <BottomNavigationBarItem key={index} route={route} selected={currentRoute === route} />
                    })
                }
            </div>
        </div>
    </div>
}


const BottomNavigationBarItem: FC<{
    route: NavigationRouteObject,
    selected: boolean,
}> = ({ route, selected }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (route?.path) {
            navigate(route.path);
        }
    }
    return <div className="flex-1 h-full flex justify-center cursor-pointer" onClick={handleClick}>
        <div className={`flex flex-col items-center selection:none text-info ${selected ? 'text-primary' : ''}`}>
            <div className={`size-6 ${selected ? 'text-primary' : ''}`}>
                {selected ? route.active : route.icon}
            </div>
            <span className={`text-[.6rem] leading-4 ${selected ? 'text-primary' : ''}`}>
                {route.name}
            </span>
        </div>
    </div>
}

export default NavigationLayout;